function IconHandLuggageUnavailable(props) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M17.23 9.22C17.8 10.15 18.13 11.25 18.13 12.42V15.1C16.72 14.19 14.94 13.6 13 13.45L11.85 14.6C11.9 14.6 11.95 14.6 12 14.6C14.46 14.6 16.64 15.37 18.13 16.56V18.75C18.13 19.95 17.16 20.92 15.96 20.92H8.05004C7.36004 20.92 6.75004 20.6 6.35004 20.1L3.07004 23.38L2.04004 22.35L5.88004 18.51V18.48L9.48004 14.88C9.49004 14.88 9.51004 14.88 9.52004 14.87L10.94 13.45C10.93 13.45 10.92 13.45 10.9 13.45L12.93 11.42H12.96L13.59 10.79V10.76L16.3 8.05C16.3 8.05 16.31 8.06 16.32 8.07L21.99 2.4L23.02 3.43L17.23 9.22ZM8.32004 13.96C7.43004 14.24 6.60004 14.62 5.88004 15.09V12.41C5.88004 10.1 7.16004 8.09 9.04004 7.05V6.88C9.04004 5.24 10.37 3.91 12 3.91C13.63 3.91 14.96 5.24 14.96 6.88V7.05C15.02 7.08 15.07 7.11 15.13 7.15L12.04 10.24H10.42V11.43H10.85L8.31004 13.97L8.32004 13.96ZM10.26 6.54C10.81 6.38 11.4 6.28 12.01 6.28C12.62 6.28 13.2 6.37 13.75 6.54C13.59 5.72 12.87 5.1 12.01 5.1C11.15 5.1 10.42 5.72 10.27 6.54H10.26Z"
				fill="currentColor"
			/>
		</svg>
	);
}

export default IconHandLuggageUnavailable;
